import React from 'react'
import ReactDOM from 'react-dom'
import * as serviceWorker from './serviceWorker'
import App from './App'
import { ThemeProvider } from '@material-ui/styles'
import theme from './react/theme/myTheme'
import { Router } from 'react-router-dom'
import { history } from './react/history'
import { create } from 'jss'
import rtl from 'jss-rtl'
import { StylesProvider, jssPreset } from '@material-ui/styles'
import { Provider } from 'react-redux'
import store from './redux/store'
import 'bootstrap-css-only'
import './style/styles.scss'
import './font-awesome/css/all.min.css'

// Configure JSS
const jss = create({ plugins: [...jssPreset().plugins, rtl()] })

ReactDOM.render(
    <Provider store={store}>
        <ThemeProvider theme={theme} >
            <StylesProvider jss={jss}>
                <Router history={history}>

                    <App />

                </Router >
            </StylesProvider>
        </ThemeProvider>
    </Provider>
    , document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()